<template>
  <report
    :title="$t('language.yearlypresentabsent')"
    :filter="filter"
    :url="url"
    :landscape="true"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.person')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.personid"
            :items="PersonList"
            item-text="name"
            item-value="id"
            :label="$t('language.person')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <div class="row">
        <div class="col-sm-6">
          <table class="table table-bordered w-100">
            <thead>
              <tr>
                <th :colspan="data.summary.length" class="text-left">
                  <h3>{{ $t("language.summary") }}</h3>
                </th>
              </tr>
              <tr>
                <th v-for="item in data.summary" :key="item.status">
                  {{ getlabel(item.status) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="item in data.summary" :key="item.status">
                  {{ item.totaldays }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <table
            v-if="data.leavesummary.length > 0"
            class="table table-bordered w-100"
          >
            <thead>
              <tr>
                <th :colspan="6" class="text-left">
                  <h3>
                    {{ $t("language.leave") + " " + $t("language.summary") }}
                  </h3>
                </th>
              </tr>
              <tr>
                <th>{{ $t("language.leave") }}</th>
                <th>{{ $t("language.assigned") }}</th>
                <th>{{ $t("language.transferred") }}</th>
                <th>{{ $t("language.total") }}</th>
                <th>{{ $t("language.taken") }}</th>
                <th>{{ $t("language.balance") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.leavesummary" :key="index">
                <td>{{ item.leave }}</td>
                <td>{{ item.assigned }}</td>
                <td>{{ item.transferred }}</td>
                <td>{{ item.total }}</td>
                <td>{{ item.taken }}</td>
                <td>{{ item.balance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <br class="v-hide" />
      <table
        v-if="data.officialvisitsummary.length > 0"
        class="table table-bordered w-100"
      >
        <thead>
          <tr>
            <th :colspan="4" class="text-left">
              <h3>
                {{
                  $t("language.officialvisit") + " " + $t("language.summary")
                }}
              </h3>
            </th>
          </tr>
          <tr>
            <th>{{ $t("language.person") }}</th>
            <th>{{ $t("language.designation") }}</th>
            <th>{{ $t("language.officialvisit") }}</th>
            <th>{{ $t("language.taken") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.officialvisitsummary" :key="index">
            <td>{{ item.person }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.officialvisit }}</td>
            <td>{{ item.taken }}</td>
          </tr>
        </tbody>
      </table>
      <br class="v-hide" />
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th
              class="text-left"
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 2
              "
            >
              <h3>{{ $t("language.detail") }}</h3>
            </th>
          </tr>
          <tr>
            <th>{{ $t("language.month") }}</th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
            <th>19</th>
            <th>20</th>
            <th>21</th>
            <th>22</th>
            <th>23</th>
            <th>24</th>
            <th>25</th>
            <th>26</th>
            <th>27</th>
            <th>28</th>
            <th>29</th>
            <th>30</th>
            <th>31</th>
            <th v-if="$store.getters.settings.datetype == 'BS'">32</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.detail" :key="index">
            <td>{{ getlabel(item.month) }}</td>
            <td>{{ item.day1 }}</td>
            <td>{{ item.day2 }}</td>
            <td>{{ item.day3 }}</td>
            <td>{{ item.day4 }}</td>
            <td>{{ item.day5 }}</td>
            <td>{{ item.day6 }}</td>
            <td>{{ item.day7 }}</td>
            <td>{{ item.day8 }}</td>
            <td>{{ item.day9 }}</td>
            <td>{{ item.day10 }}</td>
            <td>{{ item.day11 }}</td>
            <td>{{ item.day12 }}</td>
            <td>{{ item.day13 }}</td>
            <td>{{ item.day14 }}</td>
            <td>{{ item.day15 }}</td>
            <td>{{ item.day16 }}</td>
            <td>{{ item.day17 }}</td>
            <td>{{ item.day18 }}</td>
            <td>{{ item.day19 }}</td>
            <td>{{ item.day20 }}</td>
            <td>{{ item.day21 }}</td>
            <td>{{ item.day22 }}</td>
            <td>{{ item.day23 }}</td>
            <td>{{ item.day24 }}</td>
            <td>{{ item.day25 }}</td>
            <td>{{ item.day26 }}</td>
            <td>{{ item.day27 }}</td>
            <td>{{ item.day28 }}</td>
            <td>{{ item.day29 }}</td>
            <td>{{ item.day30 }}</td>
            <td>{{ item.day31 }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32 }}
            </td>
          </tr>
        </tbody>
        <tfoot v-if="data.detail.length == 0">
          <tr>
            <th
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 1
              "
            >
              {{ $t("language.nodatafound") }}
            </th>
          </tr>
        </tfoot>
        <tfoot v-if="data.detail.length > 0">
          <tr>
            <th
              align="left"
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 1
              "
            >
              {{ data.abbrText }}
            </th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
      },
      YearList: [],
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      url: "client/report/yearly/presentabsents",
    };
  },
  computed: {
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/yearly/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    getlabel(textkey) {
      return this.$t("language." + textkey.toLowerCase());
    },
  },
};
</script>
